module.exports = __webpack_public_path__ + "static/classic-black-a282b6d8c9cfc4e8970462142cd06687.svg";